import React from "react"
import AddButtonNew from "../../AddButton/AddButtonNew"

class AssignHousekeeperButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...this.props}
        this.assign_to_logs = this.assign_to_logs.bind(this)
    }


    render() {
      return (
          <div className="add-charge-button">
          <AddButtonNew
            model="User" 
            text={I18n.t('assign_housekeeper')} 
            buttonClasses="btn btn-secondary" 
            onAdd={this.assign_to_logs} 
            disabled={this.isActionDisabled(this.props.table_action)} 
            data={this.props.users}
            generalPosition="bottom"
          />
          </div>
      );
    }

    isActionDisabled(table_action) {
      if (this.props.checkboxesChecked.length >= 1 && table_action.enabled == 'multiple') {
        return false;
      } else {
        return true;
      }
    }

    toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    }

    assign_to_logs(json) {
      var data = {
        user_id: json.id,
        log_ids: this.props.checkboxesChecked
      }

      $.ajax({
        method: 'POST',
        url: `/admin/housekeeping/assign`,
        data: data
      }).done((response) => {
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('housekeeper_assigned_successfully'))
        }
      })
    }

};

export default AssignHousekeeperButton